var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quizset-button-new",on:{"click":_vm.newQuizset}},[_vm._v("\n  新しいクイズセットの作成\n")])}
var staticRenderFns = []

export { render, staticRenderFns }